import { PREFIX_BACK } from '../common/Configuration';
import { fetch } from './ResourcesService';
import { isParticipationVolontaireEnabled } from './TenantService';

const dossierUrl = `${PREFIX_BACK}dossiers/`;

const putDossier = (uid, values, urlPart) =>
  fetch(true, `${dossierUrl}${uid}/${urlPart}`, {
    method: 'PUT',
    body: JSON.stringify(values)
  });

export const getDossierByUidEntreprise = (uidEntreprise) => fetch(true, `${dossierUrl}search?uidEntreprise=${uidEntreprise}`);

export const mettreAjourParticipation = (nbSalaries, uid, { valuesAenvoye }) =>
  putDossier(uid, valuesAenvoye, `participation${nbSalaries < 50 && isParticipationVolontaireEnabled() ? 'Volontaire' : ''}`);
export const mettreAjourInteressement = (uid, { valuesAenvoye }) => putDossier(uid, valuesAenvoye, 'interessement');
export const mettreAjourPlanExistant = (uid, { valuesAenvoyer }) => putDossier(uid, valuesAenvoyer, 'planExistant');
export const mettreAjourTarification = (uid, { valuesAenvoye }, { sauvegardeSeule } = {}) =>
  putDossier(uid, valuesAenvoye, `tarification${sauvegardeSeule ? '?sauvegardeSeule=true' : ''}`);
export const mettreAjourAbondements = (uid, { dispositifs }) => putDossier(uid, dispositifs, 'abondements');
export const sendKycFields = (uid, fields) => putDossier(uid, fields, 'donneesKYC');

export const envoiEmailBulletinAvantSignature = (uid) =>
    fetch(true, `${PREFIX_BACK}dossiers/${uid}/mail-bulletin-avant-signature`, {
        method: 'POST'
    });
